import React from "react";
import Txn from "./Txn";
import { ListHeader, OpenCloseBalance } from "components";

const TxnsTView = ({
  filteredTnx = [],
  dailyCash = { in: "₹ 0", out: "₹ 0" },
  openBalance = 0,
  closeBalance = 0,
  setLoading,
  handleToggle,
}) => {
  return (
    <div className="row p-0 m-0 w-100">
      {/* Cash In Column */}
      <div
        className="col-6 list-group list-group-flush scrollbar-design overflow-auto ps-4 pe-0 px-md-3"
        style={{
          height: "calc(100vh - 200px)",
          maxHeight: "calc(100vh - 200px)",
        }}
      >
        <ListHeader type="in" amount={dailyCash.in} title="Cash In" />
        <OpenCloseBalance type="open" sum={openBalance} />
        {filteredTnx
          ?.filter((txn) => (txn.get ? txn.get("amount") : txn.amount) > 0)
          ?.map((txn, i) => (
            <Txn
              data={txn}
              key={txn.id || i}
              setLoading={setLoading}
              handleToggle={handleToggle}
            />
          ))}
      </div>

      {/* Cash Out Column */}
      <div
        className="col-6 list-group list-group-flush scrollbar-design overflow-auto pe-0 px-md-3"
        style={{
          height: "calc(100vh - 200px)",
          maxHeight: "calc(100vh - 200px)",
        }}
      >
        <ListHeader type="out" amount={dailyCash.out} title="Cash Out" />
        {filteredTnx
          ?.filter((txn) => (txn.get ? txn.get("amount") : txn.amount) < 0)
          ?.map((txn, i) => (
            <Txn
              data={txn}
              key={txn.id || i}
              setLoading={setLoading}
              handleToggle={handleToggle}
            />
          ))}
        <OpenCloseBalance type="close" sum={closeBalance} />
      </div>
    </div>
  );
};

export default TxnsTView;
